import { Injectable } from "@angular/core";
import * as utils from "@apps/patient-core/src/app/utils";
import { BaseAppInitService } from "@apps/patient-core/src/app/services/abstracts/app-init.service";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { NavigationService } from "@apps/patient-core/src/app/services/navigation.service";
import { ConciergeService } from "../concierge.service";
import { Constants } from "@apps/concierge-app/constants";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";
import { logger } from "@dentally/ui/logger";

@Injectable({
  providedIn: "root",
})
export class ConciergeAppInitService extends BaseAppInitService {
  constructor(
    private _authService: BaseAuthService,
    private _cacheService: CacheService,
    private _navigationService: NavigationService,
    private _conciergeService: ConciergeService
  ) {
    super();
  }
  protected async _doInit() {
    this.checkIfStorageSupported();

    // Automatically hide the app loading spinner if it's not hidden automatically
    utils.checkAppLoadingSpinnerIsRemoved(10);

    /*
      Check if we have previous Concierge data (stage, site ID etc) and restore it
      If we had data which was restored, we need to init for paired because this device has already been paired
    */
    if (await this._conciergeService.restoreConciergeData()) {
      await this._conciergeService.initForPaired();
    } else {
      // If we've not already paired, we need to init for pairing to allow the practice user to pair the device
      await this._conciergeService.initForPairing();
    }
  }

  public async init() {
    if (this._conciergeService.isDevicePaired) {
      // Initialize the session service first to ensure we have the session cookie set but only if the device has been paired
      await this._authService.init();
    }

    try {
      await this._doInit();
    } catch (error) {
      logger.error("Failed to initialize app", {
        error,
        conciergeData: this._cacheService.getJson(Constants.CONCIERGE_DATA_STORAGE_KEY),
        jwt: this._authService.getJWT(),
      });

      this._navigationService.navigate("/error", {
        state: {
          error: "Failed to initialise the concierge application",
        },
      });
    }
  }
}
